import { Module } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AccountState } from './AccountState'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

export const state: AccountState = {
  username: '',
  accountId: '96857305G'
}

const namespaced = true

export const account: Module<AccountState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
